// import {IdMap, Node} from './Tree';
// import cloneDeep from 'lodash/cloneDeep';
import { actions } from '../actions';
const cloneDeep = require('lodash/cloneDeep');

let actionTypes = Object.keys(actions);

export class ActionTask {

  constructor({ actionType, parameters = {}, started = false, completed = false }) {
    if (!actionTypes.includes(actionType)) {
      throw new Error(`ActionTask constructor invalid actionType ${actionType}`);
    }
    Object.assign(this, { actionType, parameters, started, completed });
  }

  clone() {
    const parameters = cloneDeep(this.parameters);
    return new ActionTask({
      actionType: this.actionType,
      parameters,
      started: this.started,
      completed: this.completed
    });
  }

}


/**
 * @property {ActionTask} actionTask
 */
export class ActionItem {

  constructor({ actionId, parentConditions = [], actionTask = null }) {

    if (isNaN(Number(actionId))) {
      throw new Error('ActionItem constructor must be pass a number for the actionId');
    }
    if (!Array.isArray(parentConditions)) {
      throw new Error('ActionItem constructor must be passed an array of parentConditions');
    } else {
      parentConditions.forEach(pc => {
        if (isNaN(Number(pc.actionId))) {
          throw new Error(`ActionItem constructor: parentCondition must have an id ${pc.actionId}`);
        }
        if (!pc.status) {
          pc.status = 'started';
        } else if (!['started', 'completed'].includes(pc.status)) {
          throw new Error(`ActionItem constructor: parentConditions invalid status: ${pc.status}`);
        }
      });
    }
    if (actionTask && !(actionTask instanceof ActionTask)) {
      throw new Error('ActionItem constructor must be passed an ActionTask');
    }
    Object.assign(this, {actionId, parentConditions, actionTask});
  }

  isStarted() {
    if (!this.actionTask) {
      return false;
    }
    return this.actionTask.started;
  }

  isCompleted() {
    if (!this.actionTask) {
      return false;
    }
    return this.actionTask.completed;
  }

  clone() {
    const actionTask = this.actionTask.clone();
    return new ActionItem({
      actionId: this.actionId,
      parentConditions: cloneDeep(this.parentConditions),
      actionTask
    });
  }

}

export class ActionMap {

  constructor(map = null) {
    if (map && !(map instanceof Map)) {
      throw new Error('ActionMap constructor must be passed an instance of Map');
    }
    this.map = new Map();
    if (map instanceof Map) {
      for (let {key, value} of map.entries()) {
        this.map.set(key, value);
      }
    }
  }

  set(key, value = null) {
    if (this.map.get(key)) {
      throw new Error(`key ${key} already in ActionMap`);
    }
    if (value && !(value instanceof ActionItem)) {
      throw new Error('ActionMap.set must be passed an Action Item');
    }
    this.map.set(key, value);
  }

  get(key) {
    return this.map.get(key);
  }

  has(key) {
    return this.map.has(key);
  }

  entries() {
    return this.map.entries();
  }

  keys() {
    return this.map.keys();
  }

  values() {
    return this.map.values();
  }

  updateStartedStatus({ actionId, status }) {
    /**
     * @type ActionItem
     */
    const actionItem = this.get(actionId);
    if (actionItem) {
      /**
       * @type ActionTask
       */
      const actionTask = actionItem.actionTask;
      if (actionTask) {
        actionTask.started = status;
      }
    }
  }

  updateCompletedStatus({ actionId, status }) {
    /**
     * @type ActionItem
     */
    const actionItem = this.get(actionId);
    if (actionItem) {
      /**
       * @type ActionTask
       */
      const actionTask = actionItem.actionTask;
      if (actionTask) {
        actionTask.completed = status;
      }
    }
  }

  isStarted({ actionId }) {
    /**
     * @type ActionItem
     */
    const actionItem = this.get(actionId);
    if (actionItem) {
      /**
       * @type ActionTask
       */
      const actionTask = actionItem.actionTask;
      if (actionTask) {
        if (actionTask.started) {
          return true;
        }
      }
    }
    return false;
  }

  isCompleted({ actionId }) {
    /**
     * @type ActionItem
     */
    const actionItem = this.get(actionId);
    if (actionItem) {
      /**
       * @type ActionTask
       */
      const actionTask = actionItem.actionTask;
      if (actionTask) {
        if (actionTask.completed) {
          return true;
        }
      }
    }
    return false;
  }

  clone() {
    const map = new ActionMap();
    if (this.map instanceof Map) {
      for (let [key, value] of this.map.entries()) {
        value = value ? value.clone() : null;
        map.set(key, value);
      }
    }
    return map;
  }

}

/*
export class ActionNode {

  constructor({ id, parentId, children, actionTask }) {

    if (isNaN(Number(id))) {
      throw new Error('ActionNode must be pass a number for the id');
    }
    if (isNaN(Number(parentId))) {
      parentId = null;
    }
    if (!(actionTask instanceof ActionTask)) {
      actionTask = null;
    }
    children = Array.isArray(children) ? children : [];
    Object.assign(this, { id, parentId, children, actionTask });

  }

  clone() {
    return new Node(this);
  }


}

export class ActionTree {

  constructor(node) {
    this.map = new IdMap();

    if (node instanceof ActionNode) {
      this.root = node;
      const queue = [node];
      let current;
      while (queue.length) {
        current = queue.shift();
        this.map.set(current.id, current);
        current.children.forEach(child => {
          queue.push(child);
        });
      }
    } else {
      this.root = new ActionNode({ id: 0 });
    }
  }

  set({ parentId, id, value }) {
    const parent = this.map.get(parentId);
    if (!parent) {
      throw new Error(`Tree.add parentId ${parentId} does not exist`);
    }
    if (this.contains(id)) {
      console.log(`id ${id} already in Tree`);
      return;
    }
    let node;
    if (value && value instanceof ActionNode) {
      node = value;
    } else {
      node = new Node({parentId, id, value});
    }
    parent.addChild(node);
    this.map.set(id, node);
  }

  get(id) {
    return this.map.get(id);
  }

  contains(id) {
    return !!this.map.contains(id);
  }

  remove(id) {
    if (id === 0 || !this.map.contains(id)) {
      return false;
    }
    const node = this.map.get(id);
    const parent = this.map.get(node.parentId);
    if (!parent) {
      console.log(`Tree remove ${id} failed: parent ${node.parentId} is not in Tree`);
      return;
    }
    this.map.remove(id);
    parent.removeChild(id);
    return node;
  }

  updateValue({id, value}) {
    if (this.map.contains(id)) {
      const node = this.map.get(id);
      node.value = value;
      return node;
    }
    return false;
  }

  clone() {

  }
}
*/